import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IChatOverlaySectionState} from "../reducers/chat-overlay-section.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');
export const getChatOverlaySectionState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.chatOverlaySection);

export const getChatOverlaySectionToggled = createSelector(getChatOverlaySectionState,
  (state: IChatOverlaySectionState) =>
    state.toggled
);
